import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageHelmet from '../components/helmet/PageHelmet';
import { globalStatistic } from '../redux/actions/otherActions';
import { getPageSeo } from '../redux/actions/pageActions';
import '../instructions.css';

const InstructionsForUsersSr = () => {

    const dispatch = useDispatch();
    const [pageSeoData, setPageSeoData] = useState({});

    useEffect(() => {
        dispatch(globalStatistic(758, 'PAGE'));
        dispatch(getPageSeo(758)).then(res => {
            if (res) {
                setPageSeoData(res);
            }
        })
    }, [])

    return (
        <>
            {Object.keys(pageSeoData).length !== 0 &&
                <PageHelmet
                    title={pageSeoData ? `${pageSeoData.acSeoTitle}` : "Ewe Comp"}
                    description={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    keywords={pageSeoData ? `${pageSeoData.acSeoKeywords}` : ""}
                    ogDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                    ogTitle={pageSeoData ? `${pageSeoData.acSeoTitle}` : ""}
                    ogUrl={pageSeoData ? `https://ewe.rs/${pageSeoData.acSeoUrl}` : ""}
                    ogImg="https://www.ewe.rs/media/ewe-og-img.jpg"
                    ogType="article"
                    twitterDescription={pageSeoData ? `${pageSeoData.acSeoDescription}` : ""}
                />
            }
            <div className="instructions-container" style={{
                backgroundImage: "url('/images/uputstvo-pozadina.jpg')",
            }}>
                <div className="page-header-instructions">
                    <img src="/images/uputstvo-naslov.png" className="img-header-instructions" alt="Uputstvo" />
                </div>
                <div className="container-content-instructions">

                    <div className="page-body">
                        <div className="left-column">
                            <div className="block">
                                <div className="block-new">
                                    <h1>VAŠA KORPA</h1>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Znamo da ponekad prilikom naručivanja naše robe imate potrebu da napravite
                                        <strong>više različitih korpi</strong> za nabavku. Bilo da je to za nekog vašeg kupca, ili je u pitanju neka
                                        veća kupovina za koju čekate potvrdu, od sada to možete raditi kreiranjem više lista artikala sa željenim količinama.
                                        Dovoljno je samo da na stranici predviđenoj za uređivanje korpi dodate novu korpu i označite je kao onu u koju želite
                                        da dodajete artikle. Korpa nikada neće biti obrisana, a vrlo jednostavno možete da potvrdite kupovinu kada se za to odlučite.
                                    </p>
                                    <p>
                                        Nakon klika na <strong>Završi kupovinu</strong> potrebno je popuniti formu i izabrati opciju plaćanja.
                                    </p>
                                    <p>
                                        Odababirom opcije <strong>Potvrdi poruđžbine </strong>, nalog će biti poslat komercijalisti na obradu, pri čemu roba neće biti na čvrstoj
                                        rezervaciji. U ovom slučaju, postoji mogućnost izmene u dogovoru sa komercijalistom.
                                    </p>
                                    <img src="/images/vasa_korpa_sr.png" alt="Korpa" className="block-image-wide" />
                                </div>
                            </div>
                            <div className="block">
                                <div className="block-new">
                                    <h1>LOGISTIKA</h1>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <h3>Pregled porudžbina</h3>
                                    <p>
                                        Ovde možete pogledati istoriju i statuse Vaših porudžbina.
                                    </p>
                                    <img src="/images/logistika_sr.png" alt="Logistika" className="block-image-wide" />
                                    <h3>Raspored isporuke po gradovima</h3>
                                    <p>
                                        Ovde možete saznati više o tome kada možete da očekujete Vašu robu i koje su cene usluga transporta.
                                    </p>
                                    <h3>Mi isporučujemo Vašem kupcu</h3>
                                    <p>
                                        Kao i dosad, imate mogućnost da izaberete opciju da mi isporučimo robu direktno Vašem kupcu. Na taj način štedite sebi prostor
                                        a kupcima vreme čekanja porudžbine.
                                    </p>
                                    <img src="/images/logistika-2-sr.jpg" alt="Logistika" className="block-image-medium" />
                                    <h3>PickUp & Return</h3>
                                    <p>
                                        U saradnji sa servisom Nepo System doo obezbedili smo besplatnu PickUp&Return uslugu za sve uređaje kupljene kod nas, a za koju
                                        imate reklamaciju. Sve što trebate da uradite je da popunite zahtev za preuzimanje robe za reklamaciju koji se nalazi na ovoj stranici.
                                    </p>
                                </div>
                            </div>
                            <div className="block">
                                <h1>FINANSIJE</h1>
                                <div className="block-new-h3">
                                    <h3>Pregled valutacije</h3>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Ovde možete saznati sve o sumi i vremenu dospeća Vaših zaduženja, kao i o ukupnom dugu, dugu van valute i uslovima plaćanja.
                                    </p>
                                    <img src="/images/valutacija_sr.jpg" alt="Valutacija" className="block-image-wide" />

                                    <div className="block-new-h3">
                                        <h3>Pregled porudžbina</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Ovde možete istoriju i statuse vaših porudžbina.
                                    </p>
                                </div>
                            </div>
                            <div className="block">
                                <h1>PODRŠKA ZA KLIJENTE</h1>
                                <h3>Briga o klijentima</h3>
                                <div className="text-img-container">
                                    <p>
                                        Niste zadovoljni sa nekom od naših usluga? Niste dobili odgovor na zahtev za registraciju na našem portalu? Imate problem
                                        sa isporukom robe? Niste dobili odgovor na zahtev za ponudu?
                                    </p>
                                    <p>
                                        Ne brinite! Mi smo tu da Vam odgovorimo na svako pitanje i da rešimo bilo koji problem koji imate u poslovanju sa našom kompanijom.
                                        Pozivamo Vas da budete slobodni da podelite sa nama sve Vaše primedbe ili sugestije kako bismo bili bolji a Vi u potpunosti zadovoljni.
                                    </p>
                                    <img src="/images/briga-o-klijentima-sr.jpg" alt="Briga o klijentima" className="block-image-wide" />
                                    <h3>Kontakt informacije</h3>
                                    <p>
                                        Ukoliko želite da stupite u kontakt sa nama, na ovoj stranici ćete naći sve sto Vam je potrebno za to.
                                    </p>
                                    <h3>Preuzmite materijal za naš sajt</h3>
                                    <p>
                                        Nudimo Vam jednostavan i praktičan način da svojim kupcima predstavite svoju ponudu. Preuzmite blanko newsletter u kojem nema oznaka
                                        i cena naše kompanije, već je ostavljen prostor da lako dopišete svoje i pošaljete krajnjem korisniku.
                                    </p>
                                    <img src="/images/preuzmite-materijal-sr.jpg" alt="Preuzmite materijal" className="block-image-wide" />
                                </div>
                            </div>

                            <div className="block">
                                <h1>PODEŠAVANJA</h1>
                                <h3>Moj nalog/Osnovni podaci</h3>
                                <div className="text-img-container">
                                    <p>
                                        Na pravom ste mestu ukoliko želite da promenite Vaše osnovne podatke ili lozinku.
                                    </p>
                                    <img src="/images/moj-nalog-sr.jpg" alt="Moj nalog" className="block-image-wide" />
                                    <div className="block-new-h3">
                                        <h3>Moj nalog/Podešavanja</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Jako važan deo podešavanja svakako jeste i podrazumevano podešavanje prikaza valute, prikaza cena sa ili bez PDV-a, načina sortiranja
                                        proizvoda u katalogu, tipa pregleda kataloga, margine ili marže.
                                    </p>
                                    <img src="/images/moj-nalog-podesavanja-sr.jpg" alt="Moj nalog podesavanja" className="block-image-wide" />
                                    <div className="block-new-h3">
                                        <h3>Kompanija</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Ključan deo podešavanja je upravo ovaj odeljak, gde morate podesiti vizuale kako bi mogli da pravite vaše ponude. Tu se pre svega misli
                                        na Logo, Header i Footer koji će se naći na svakoj vašoj ponudi. Takođe, ovo je mesto gde podešavate E-mail adrese.
                                    </p>
                                    <h3>Lista želja</h3>
                                    <p>
                                        U ovom odeljku možete pregledati sve artikle koje ste stavili u listu želja klikom na srce. Takođe, odavde lako možete dodati artikle
                                        u korpu, pritom birajući količinu istih.
                                    </p>
                                    <img src="/images/lista-zelja-sr.jpg" alt="Lista zelja" className="block-image-wide" />
                                    <div className="block-new-h3">
                                        <h3>Admin</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Ukoliko više različitih korisnika unutar vaše firme koristi naš portal za poručivanje, onda će Vam ovo biti nezaobilazan alat.
                                        Sve što trebate da uradite je da kliknete na Dodaj korisnika i izaberete njegov nivo pristupa. Bitno je napomenuti da Admin može videti
                                        sve, dok Neulogovani korisnik ne može videti sve, dok Neulogovani korisnik ne može videti Finansije.
                                    </p>
                                    <img src="/images/admin-sr.jpg" alt="Admin" className="block-image-wide" />
                                </div>
                            </div>
                            <div className="block">
                                <h1>OBAVEŠTENJA</h1>
                                <div className="text-img-container">
                                    <p>
                                        Budite informisani o dešavanjima naše kompanije, od uvođenja novih usluga i brendova, sve do izmena u radnom vremenu i rasporedu razvoza robe.
                                    </p>
                                    <img src="/images/obavestenja-sr.jpg" alt="Obavestenja" className="block-image-wide" />
                                </div>
                            </div>
                        </div>
                        <div className="right-column">
                            <div className="block">
                                <div className="block-new">
                                    <h1>DASHBOARD</h1><div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Dashboard je zamišljen tako da na jednom mestu brzo i lako možete videti sve najvažnije stavke.
                                    </p>
                                    <img src="/images/dashboard-sr.jpg" alt="Dashboard" className="block-image-wide" />
                                </div>
                            </div>
                            <div className="block">
                                <div className="block-new">
                                    <h1>KUPOVINA</h1>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Potrudili smo se da u ovaj meni ubacimo sve što je potrebno kako biste sa uživanjem uspeli da obavite Vašu kupovinu.
                                    </p>
                                    <img src="/images/kupovina-sr.jpg" alt="Kupovina" className="block-image-small" />
                                    <h3>Loyalty shop</h3>
                                    <p>
                                        Stari Loyalty shop u novom dizajnu, pravila su ista kao i dosad: Za pravo kupovine proizvoda iz newerovatne ponude, kvalifikujete se istog
                                        trenutka kada ispunite svoj mesečni target.
                                    </p>
                                    <p>
                                        Mesečni target koji Vam je postavljen možete videti na početku svakog meseca na Vašem profilu na B2B portalu, na sajtu https://www.ewe.rs/profil.
                                    </p>
                                    <p>
                                        Target se može ostvariti bilo kojeg dana u mesecu, ali pravo na kupovinu možete realizovati najranije 25, a nakasnije do poslednjeg dana
                                        u tekućem mesecu.
                                    </p>
                                    <img src="/images/loyalty-sr.jpg" alt="Loyalty" className="block-image-wide" />
                                </div>
                            </div>
                            <div className="block">
                                <div className="block-new">
                                    <h1>AUKCIJE</h1>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Ewe Vam pruža priliku da kupite artikle po ceni koju samu odredite i da se nadmećete sa drugim kupcima na licitaciji.
                                    </p>
                                    <p>
                                        Mehanizam funkcioniše kao i kod svake druge aukcije. Dajete ponude, prikazano je vreme trajanja aukcije, kao i trenutna cena. Na mejl dobijate
                                        obaveštenje kad je Vaša ponuda nadmašena i ako je Vaša ponuda najviša na kraju licitacije.
                                    </p>
                                    <img src="/images/aukcije-sr.jpg" alt="Aukcije" className="block-image-wide" />
                                    <h3>Outlet</h3>
                                    <p>
                                        Ovde se nalaze artikli koji imaju neki nedostatak, kao što su ogrebotine, oštećenja, drugi tragovi korišćenja, oštećeno pakovanje, neadekvatna ambalaža itd.
                                    </p>
                                    <div className="block-new-h3">
                                        <h3>Novo u ponudi</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Istražite potpuno nove proizvode u našoj ponudi!
                                    </p>
                                    <h3>Ponovo na stanju</h3>
                                    <p>
                                        Saznajte koji proizvodi su upravo dopunjeni.
                                    </p>
                                    <div className="block-new-h3">
                                        <h3>Najprodavaniji artikli</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Zanima Vas šta se najviše prodaje? Ovo je pravo mesto za Vas!
                                    </p>
                                    <div className="block-new-h3">
                                        <h3>Preporučujemo Vam</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Odabrali smo proizvode za koje mislimo da će Vam se svideti. Naša preporuka, za Vaš užitak!
                                    </p>
                                    <div className="block-new-h3">
                                        <h3>Poslednje pregledano</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Ukoliko ne možete da se setite proizvoda koje ste upravo pregledali, bez brige, ova opcija je tu za Vas!
                                    </p>
                                    <h3>Lista želja</h3>
                                    <p>
                                        Svi Vaši omiljeni proizvodi na jednom mestu!
                                    </p>
                                    <div className="block-new-h3">
                                        <h3>Roba rezervisana za Vas</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Sve nedoumice ovde nestaju! Saznajte koja roba je rezervisana za Vas, kojim tipom rezervacije i do kog datuma.
                                    </p>
                                    <img src="/images/rezervacije-sr.jpg" alt="Rezervacije" className="block-image-wide" />
                                </div>
                            </div>
                            <div className="block">
                                <h1>KATALOG PROIZVODA</h1>
                                <div className="block-new-h3">
                                    <h3>Napravi svoju ponudu</h3>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Prilikom pregleda kataloga proizvoda, sada možete napraviti i svoju ponudu sa odabirom marže i čuvanjem takve ponude u PDF formatu.
                                    </p>
                                    <img src="/images/kreiranje-ponude-sr.jpg" alt="Ponuda" className="block-image-wide" />
                                </div>
                            </div>
                            <div className="block">
                                <h1>STRANICA PROIZVODA</h1>
                                <div className="block-new-h3">
                                    <h3>Proizvodi u 3D</h3>
                                    <div className="new-image">
                                        <img src="/images/novo-sr.png" alt="Novo" />
                                    </div>
                                </div>
                                <div className="text-img-container">
                                    <p>
                                        Od sada više ne morate da odlazite u prodavnicu da vidite kako neki proizvod izgleda, sada to možete uraditi jednim klikom, na našem portalu!
                                        Sve što trebate da uradite je da kliknete na 3D ikonicu u galeriji slika proizvoda. Mi smo se potrudili da fotografišemo što više.
                                    </p>
                                    <img src="/images/3d-proizvod-sr.jpg" alt="3d prozivod" className="block-image-medium" />
                                    <div className="block-new-h3">
                                        <h3>YouTube video unutar galerije</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Kako bi na najbolji način mogli da doživite proizvod, uveli smo još jednu novinu. Od sada, u galeriji možete pregledati i video opis samog proizvoda.
                                    </p>
                                    <img src="/images/youtube-sr.jpg" alt="Youtube" className="block-image-medium" />
                                    <div className="block-new-h3">
                                        <h3>Dodatni opis proizvoda</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Da bi proizvod u potpunosti oživeo, uveli smo i dodatne opise za određene proizvode, koji na najbolji mogući način ističu njegove glavne karakteristike.
                                        Nadamo se da će Vam se svideti!
                                    </p>
                                    <img src="/images/opis-proizvoda-sr.jpg" alt="Opis prozivoda" className="block-image-medium" />
                                    <div className="block-new-h3">
                                        <h3>Margina, Marža i Avans</h3>
                                        <div className="new-image">
                                            <img src="/images/novo-sr.png" alt="Novo" />
                                        </div>
                                    </div>
                                    <p>
                                        Prilikom pregleda proizvoda, kod cene proizvoda nalaze se i dodatne opcije koje mislimo da će vam dosta značiti u vašem poslovanju. U polju Marža/Margina
                                        će se nalaziti vrednost koju ste prethodno predefinisali u vašim podešavanjima naloga. Promene Vaše prodajne cene i Razlike u ceni dešavaju se u realnom
                                        vremenu, tj. čim ukucate vrednost u polju Marža/Margina. Ukoliko ipak želite da promenite vrednosti Marže/Margine, to možete učiniti lako i ta promena
                                        će biti primenjena samo tada i samo za taj proizvod. Kada budete pregledali neki drugi proizvod, jednostavno osvežite tu stranicu proizvoda i u polju
                                        Marža/Margina će vam se ponovo pojaviti vrednosti koje ste ranije predefinisali. Takođe, čekiranjem kućice Avans u realnom vremenu možete videti promenu
                                        same cene, kao i koliki je avans u procentima za taj proizvod.
                                    </p>
                                    <img src="/images/marza-sr.jpg" alt="Marža" className="block-image-wide" />
                                    <h3>Uporedni prikaz proizvoda</h3>
                                    <p>
                                        Čekiranjem kućice Uporedi na strani proizvoda, možete staviti do 4 proizvoda u listu za upoređivanje proizvoda. Nakon što odaberete željene proizvode
                                        za upoređivanje, i kliknete na Uporedi proizvode, dobićete uporedni prikaz proizvoda.
                                    </p>
                                    <img src="/images/uporedjivanje-sr.jpg" alt="Uporedjivanje" className="block-image-wide" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default InstructionsForUsersSr;